import styled from 'styled-components'

export const ComparisonMain = styled.div``